import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Icon,
  Image,
  KCol,
  KPanel,
  KRow,
  Label,
  LayoutLeft,
  Menu,
  MenuItem,
  SubMenu,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withInlineOverlayNav } from "../../shared/hoc/with-inline-overlay-nav";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenBase } from "./blank-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [
  { key: "272202", screenName: "AnaSayfa", params: {}, isStartingScreen: true },
  {
    key: "292340",
    screenName: "Arama",
    params: { Ara: "" },
    isStartingScreen: false,
  },
  {
    key: "342795",
    screenName: "SiparisDurumlari",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "137793",
    screenName: "TeklifDurumlari",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "353618",
    screenName: "BakiyeSiparisleri",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "482230",
    screenName: "CariHesap",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "727547",
    screenName: "YaslandirmaRapor",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "29445",
    screenName: "KapatilmamisFaturalar",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "387729",
    screenName: "ExceldenAktar",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "233748",
    screenName: "PlasiyerHome",
    params: {},
    isStartingScreen: false,
  },
];

class Blank_Screen extends Blank_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin
          spinning={
            this.state.spinnerCount > 0 || !this.context?.isMasterPageInitLoaded
          }
        >
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              initialValues={{
                blank_681018_value: "61438a84-6938-4253-d68d-08dd9ed6a6a2",
                blank_345994_value: "6164dba9-1e36-4884-cd14-08dd2c25cbac",
                blank_293630_value: {
                  collapsed: false,
                  selectedKey: "Ana Sayfa",
                },
                blank_257984_value: {
                  collapsed: false,
                  selectedKey: "Ana Sayfa",
                },
              }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <div style={{} as any}>
                <div style={{ display: "flex" } as any}>
                  <LayoutLeft
                    key="-12"
                    id="Minus12"
                    id="blank_layout_left"
                    layoutPosition={1}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "left",
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        width: "100px",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KRow
                      key="70019"
                      id="70019"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 18,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 15,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KCol
                        key="205364"
                        id="205364"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderTopLeftRadius: 10,
                            borderTopRightRadius: 10,
                            borderBottomRightRadius: 10,
                            borderBottomLeftRadius: 10,
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            backgroundColor: "rgba(0, 0, 0, 1)",
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            textAlign: "-webkit-center",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KRow
                          key="558053"
                          id="558053"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 0,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="82798"
                            id="82798"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 8,
                                paddingBottom: 0,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-center",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Icon
                              key="889076"
                              id="889076"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.BlankComponent_889076_onClick();
                              }}
                              showCursorPointer
                              iconName="menu"
                              iconLibrary="material"
                              style={
                                {
                                  borderTopLeftRadius: 7,
                                  borderTopRightRadius: 7,
                                  borderBottomRightRadius: 7,
                                  borderBottomLeftRadius: 7,
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  backgroundColor: "rgba(0, 0, 0, 1)",
                                  paddingTop: 5,
                                  paddingRight: 5,
                                  paddingBottom: 5,
                                  paddingLeft: 5,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "20px",
                                  color: "rgba(255, 255, 255, 1)",
                                  letterSpacing: "1px",
                                } as any
                              }
                            ></Icon>
                          </KCol>
                        </KRow>
                        <KRow
                          key="934840"
                          id="934840"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 8,
                              paddingBottom: 0,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="98413"
                            id="98413"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.BlankComponent_98413_onClick();
                            }}
                            showCursorPointer
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 8,
                                paddingBottom: 0,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-center",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="blank_681018_value"
                            >
                              <Image
                                key="681018"
                                id="681018"
                                visibility={this.state.isComp681018Visible}
                                zoomOnClick={false}
                                imageFit="fit"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    width: "130px",
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></Image>
                            </Form.Item>
                          </KCol>
                        </KRow>
                        <KRow
                          key="641897"
                          id="641897"
                          visibility={this.state.isComp641897Visible}
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="458938"
                            id="458938"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                textAlign: "-webkit-center",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="blank_345994_value"
                            >
                              <Image
                                key="345994"
                                id="345994"
                                zoomOnClick={false}
                                imageFit="fill"
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    width: "40px",
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></Image>
                            </Form.Item>
                          </KCol>
                        </KRow>
                        <Form.Item
                          className="kFormItem"
                          name="blank_293630_value"
                          noStyle
                        >
                          <Menu
                            key="293630"
                            id="293630"
                            menuMap={menuMap}
                            options={this.state.dataSource_293630}
                            mode="vertical"
                            primaryColor="rgba(252, 17, 22, 1)"
                            collapsible={false}
                            collapsedButtonColor="rgba(252, 17, 22, 1)"
                            hamburgerControl={false}
                            closeSiblingSubmenusOnOpen={true}
                            style={
                              {
                                backgroundColor: "rgba(0, 0, 0, 1)",
                                paddingTop: 8,
                                paddingRight: 16,
                                paddingBottom: 8,
                                paddingLeft: 16,
                                width: "212px",
                                alignItems: "center",
                                textAlign: "-webkit-center",
                                display: "inline",
                              } as any
                            }
                          >
                            <MenuItem
                              key={272202}
                              id="272202"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.BlankComponent_272202_onClick();
                              }}
                              showCursorPointer
                              key={272202}
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                272202,
                                "label",
                                this.defaultML
                              )}
                              icon="home"
                              iconLibrary="material"
                              style={
                                {
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "10px",
                                  color: "rgba(255, 255, 255, 1)",
                                } as any
                              }
                            ></MenuItem>
                            <MenuItem
                              key={292340}
                              id="292340"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.BlankComponent_292340_onClick();
                              }}
                              showCursorPointer
                              key={292340}
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                292340,
                                "label",
                                this.defaultML
                              )}
                              icon="search"
                              iconLibrary="material"
                              style={
                                {
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "10px",
                                  color: "rgba(255, 255, 255, 1)",
                                } as any
                              }
                            ></MenuItem>
                            <SubMenu
                              key={880528}
                              id="880528"
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                880528,
                                "label",
                                this.defaultML
                              )}
                              icon="local_shipping"
                              iconLibrary="material"
                              style={
                                {
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "10px",
                                  color: "rgba(255, 255, 255, 1)",
                                } as any
                              }
                            >
                              <MenuItem
                                key={342795}
                                id="342795"
                                onClick={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.BlankComponent_342795_onClick();
                                }}
                                showCursorPointer
                                key={342795}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  342795,
                                  "label",
                                  this.defaultML
                                )}
                                iconLibrary="material"
                                style={
                                  {
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "10px",
                                    color: "rgba(255, 255, 255, 1)",
                                  } as any
                                }
                              ></MenuItem>
                              <MenuItem
                                key={137793}
                                id="137793"
                                onClick={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.BlankComponent_137793_onClick();
                                }}
                                showCursorPointer
                                visibility={this.state.isComp137793Visible}
                                visibilityCondition={(rowData: object) =>
                                  ReactSystemFunctions.isEqualTo(
                                    this.state.GetParametreler[0]?.isTeklif?.toString(),
                                    "true"
                                  )
                                }
                                key={137793}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  137793,
                                  "label",
                                  this.defaultML
                                )}
                                iconLibrary="material"
                                style={
                                  {
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "10px",
                                    color: "rgba(255, 255, 255, 1)",
                                  } as any
                                }
                              ></MenuItem>
                              <MenuItem
                                key={353618}
                                id="353618"
                                onClick={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.BlankComponent_353618_onClick();
                                }}
                                showCursorPointer
                                key={353618}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  353618,
                                  "label",
                                  this.defaultML
                                )}
                                iconLibrary="material"
                                style={
                                  {
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "10px",
                                    color: "rgba(255, 255, 255, 1)",
                                  } as any
                                }
                              ></MenuItem>
                            </SubMenu>
                            <SubMenu
                              key={273446}
                              id="273446"
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                273446,
                                "label",
                                this.defaultML
                              )}
                              icon="euro"
                              iconLibrary="material"
                              style={
                                {
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "10px",
                                  color: "rgba(255, 255, 255, 1)",
                                } as any
                              }
                            >
                              <MenuItem
                                key={482230}
                                id="482230"
                                onClick={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.BlankComponent_482230_onClick();
                                }}
                                showCursorPointer
                                key={482230}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  482230,
                                  "label",
                                  this.defaultML
                                )}
                                iconLibrary="material"
                                style={
                                  {
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "10px",
                                    color: "rgba(255, 255, 255, 1)",
                                  } as any
                                }
                              ></MenuItem>
                              <MenuItem
                                key={727547}
                                id="727547"
                                onClick={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.BlankComponent_727547_onClick();
                                }}
                                showCursorPointer
                                key={727547}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  727547,
                                  "label",
                                  this.defaultML
                                )}
                                iconLibrary="material"
                                style={
                                  { color: "rgba(255, 255, 255, 1)" } as any
                                }
                              ></MenuItem>
                              <MenuItem
                                key={29445}
                                id="29445"
                                onClick={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.BlankComponent_29445_onClick();
                                }}
                                showCursorPointer
                                visibility={this.state.isComp29445Visible}
                                key={29445}
                                label={ReactSystemFunctions.translate(
                                  this.ml,
                                  29445,
                                  "label",
                                  this.defaultML
                                )}
                                iconLibrary="material"
                                style={{} as any}
                              ></MenuItem>
                            </SubMenu>
                            <MenuItem
                              key={387729}
                              id="387729"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.BlankComponent_387729_onClick();
                              }}
                              showCursorPointer
                              key={387729}
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                387729,
                                "label",
                                this.defaultML
                              )}
                              icon="beenhere"
                              iconLibrary="material"
                              style={
                                {
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "10px",
                                  color: "rgba(255, 255, 255, 1)",
                                } as any
                              }
                            ></MenuItem>
                            <MenuItem
                              key={233748}
                              id="233748"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.BlankComponent_233748_onClick();
                              }}
                              showCursorPointer
                              visibility={this.state.isComp233748Visible}
                              visibilityCondition={(rowData: object) =>
                                ReactSystemFunctions.isEqualTo(
                                  this.state.GetKullanici[0]?.isPlasiyer?.toString(),
                                  "true"
                                )
                              }
                              key={233748}
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                233748,
                                "label",
                                this.defaultML
                              )}
                              icon="arrow_forward_ios"
                              iconLibrary="material"
                              style={
                                {
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "10px",
                                  color: "rgba(252, 17, 22, 1)",
                                } as any
                              }
                            ></MenuItem>
                          </Menu>
                        </Form.Item>
                        <Label
                          key="28689"
                          id="28689"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.BlankComponent_28689_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isComp28689Visible}
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            28689,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        ></Label>
                        <KRow
                          key="31668"
                          id="31668"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="291184"
                            id="291184"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KPanel
                              key="993851"
                              id="993851"
                              scrolling="hidden"
                              scrollRadius={false}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  height: "25vh",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></KPanel>
                          </KCol>
                        </KRow>
                        <KRow
                          key="484323"
                          id="484323"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 8,
                              paddingLeft: 0,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KCol
                            key="370403"
                            id="370403"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 8,
                                paddingLeft: 0,
                                alignItems: "flex-start",
                                textAlign: "-webkit-center",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="blank_257984_value"
                              noStyle
                            >
                              <Menu
                                key="257984"
                                id="257984"
                                menuMap={menuMap}
                                options={this.state.dataSource_257984}
                                mode="vertical"
                                primaryColor="rgba(217, 217, 217, 1)"
                                collapsible={false}
                                collapsedButtonColor="rgba(252, 17, 22, 1)"
                                hamburgerControl={false}
                                closeSiblingSubmenusOnOpen={false}
                                style={
                                  {
                                    backgroundColor: "rgba(0, 0, 0, 1)",
                                    paddingTop: 8,
                                    paddingRight: 16,
                                    paddingBottom: 8,
                                    paddingLeft: 16,
                                    width: "212px",
                                    alignItems: "center",
                                    textAlign: "-webkit-center",
                                    display: "inline",
                                  } as any
                                }
                              >
                                <MenuItem
                                  key={343071}
                                  id="343071"
                                  onClick={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.BlankComponent_343071_onClick();
                                  }}
                                  showCursorPointer
                                  key={343071}
                                  label={ReactSystemFunctions.translate(
                                    this.ml,
                                    343071,
                                    "label",
                                    this.defaultML
                                  )}
                                  icon="logout"
                                  iconLibrary="material"
                                  style={
                                    {
                                      borderTopLeftRadius: 10,
                                      borderTopRightRadius: 10,
                                      borderBottomRightRadius: 10,
                                      borderBottomLeftRadius: 10,
                                      backgroundColor: "rgba(72, 72, 72, 1)",
                                      color: "rgba(255, 255, 255, 1)",
                                    } as any
                                  }
                                ></MenuItem>
                              </Menu>
                            </Form.Item>
                          </KCol>
                        </KRow>
                      </KCol>
                    </KRow>
                  </LayoutLeft>
                  <div
                    id="masterRootDI_wrapper"
                    style={{ flex: "auto", background: "#f0f2f5" } as any}
                  >
                    <div style={{ display: "flex" } as any}>
                      <div
                        id="masterRootDI"
                        style={
                          {
                            flex: "auto",
                            overflow: "hidden auto",
                            maxWidth: "100vw",
                            width: 0,
                            position: "relative",
                            height: "calc(100vh - 6px)",
                          } as any
                        }
                      >
                        <>{this.props.children}</>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          withInlineOverlayNav(
            connect(mapStateToProps, mapDispatchToProps)(Blank_Screen)
          )
        )
      )
    )
  )
);
export { tmp as Blank_Screen };
//export default tmp;
//export { tmp as Blank_Screen };
